import React from 'react';
import { colors } from 'styleguide/colors';
import { FlexRow } from 'styleguide/Row';
import { Spacing } from 'styleguide/spacing';
import { TextXSRegular } from 'styleguide/Texts';
import { ThemedIcon } from 'styleguide/ThemedIcon';

interface OnlyYouIndicatorProps {
  tint?: string;
  isCoached?: boolean;
}

export const OnlyYouIndicator = ({ tint, isCoached }: OnlyYouIndicatorProps) => {
  const themeColorOverride = {
    dark: tint || colors.darkmodeNeutral500,
    light: tint || colors.darkmodeNeutral500,
  };
  return (
    <FlexRow style={{ gap: Spacing.xs / 2 }}>
      <ThemedIcon type="padlock" {...themeColorOverride} />
      <TextXSRegular style={{ color: tint }}>
        {isCoached ? 'Only you and your coach' : 'Only you'}
      </TextXSRegular>
    </FlexRow>
  );
};
